import type { Organism } from '@verndale/core';

const globModules: Organism[] = [];

export default globModules;
